module.exports = __webpack_public_path__ + "static/media/app-image.4922bf85.png";